import Cooking from './cooking/Cooking';
import CookingTimeAndPeople from './cookingTimeAndPeople/CookingTimeAndPeople';
import RecipeCover from './cover/Cover';
import Detail from './Detail';
import RecipeIngredient from './ingredient/Ingredient';
import RelatedRecipe from './relatedRecipe/RelatedRecipe';
import RelatedTips from './relatedTips/RelatedTips';
export { Cooking, CookingTimeAndPeople, Detail, RecipeCover, RecipeIngredient, RelatedRecipe, RelatedTips };